// Some menu items can be hidden by CSS, so we need to check their visibility, including up a few layers
// Note there's also a ts version in: frontend/common/lib/isElementVisible.ts
export const isElementVisible = (element) => {
  const style = window.getComputedStyle(element)
  if (style.display === "none" || style.visibility === "hidden") {
    return false
  }

  let parent = element.parentElement
  while (parent) {
    const parentStyle = window.getComputedStyle(parent)
    if (parentStyle.display === "none" || parentStyle.visibility === "hidden") {
      return false
    }
    parent = parent.parentElement
  }

  return true
}

export default isElementVisible
